import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";

function RSVPFinished() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const success = searchParams.get("success") || "";

    return (success === "false" ?
        <div>
            <p>
                Error! Our website is not working and we could not record your RSVP response.
                Please reach out to Thuyan and Jerry to RSVP. We appologize for the inconvenience!
            </p>
        </div>
        :
        <div className="space-y-14">
            <div className="space-y-4">
                <p>
                    Thank you! Your RSVP response has been recorded. You&apos;ll receive a confirmation email.
                </p>

                <p>
                    If you&apos;re not able to make it, we&apos;ll truly miss you. Otherwise, we can&apos;t wait to celebrate with you!
                </p>
            </div>

            <div className="space-y-6">
                <h3 className="text-gray-900 text-3xl">What&apos;s Next?</h3>

                <p>
                    If you haven&apos;t booked your travel and accommodations yet, we recommend doing so as soon as possible.
                    Our{" "}
                    <span
                        className="text-bronze hover:text-gold hover:underline hover:cursor-pointer"
                        onClick={() => navigate("/hotels")}
                    >
                        Hotels
                    </span>{" "}
                    page has some recommended options.
                </p>

                <p>
                    Be sure to check out our{" "}
                    <span
                        className="text-bronze hover:text-gold hover:underline hover:cursor-pointer"
                        onClick={() => navigate("/QandA")}
                    >
                        Q&amp;A
                    </span>{" "}
                    page for answers to frequently asked questions.
                </p>
            </div>

            <p
                className="pb-8 back-to-home text-base text-bronze hover:text-gold hover:underline hover:cursor-pointer"
                onClick={() => navigate("/home")}
            >
                Return to Home Page
            </p>
        </div>

    )
}

export default RSVPFinished;